import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CartasService } from "../cartas.service";
import { MyErrorStateMatcher, RequireMatch } from "src/app/utils/requireMatch";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";

@Component({
  selector: "app-form-cartas",
  templateUrl: "./form.component.html",
})
export class CartasCompromisoForm implements OnInit {
  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;
  public count = 1;

  @Input("list") list: any[];
  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();

  filteredOptions: Observable<any[]>;
  matcher = new MyErrorStateMatcher();

  constructor(private fb: FormBuilder, public service: CartasService) {}

  public ngOnInit() {
    this.buildForm();
  }
  public setStanby() {
    this.count = 1;
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.form.reset();
    this.form.controls["Chofer"].enable();
    this.form.controls["Parrafos"].enable();
  }

  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;

    const chofer = this.list.find(
      (f) => f.IdTrabajador == this.defaults?.IdChofer
    );

    this.form.controls["Chofer"].setValue(chofer);
    this.form.controls["Parrafos"].patchValue(this.defaults?.Parrafos);
    this.form.controls["Chofer"].disable();
    this.form.controls["Parrafos"].disable();
  }

  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    const dataForm = this.form.value;
    const data = { ...dataForm, IdChofer: dataForm.Chofer.IdTrabajador };
    this.onsave.emit({
      mode: this.mode,
      value: data,
    });
  }

  public update() {
    const dataForm = this.form.value;
    const data = { ...dataForm, IdChofer: dataForm.Chofer.IdTrabajador };
    this.onsave.emit({
      mode: this.mode,
      value: data,
    });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      Parrafos: ["", [Validators.required]],
      Chofer: new FormControl("", [Validators.required, RequireMatch]),
    });
    this.filteredOptions = this.form.controls["Chofer"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
  }
  displayWith(item?: any): string | undefined {
    return item ? item.Nombre : undefined;
  }
  private _filter(value: any): string[] {
    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Nombre.toLowerCase();

    return this.list.filter((option) =>
      option.Nombre.toLowerCase().includes(filterValue)
    );
  }
}
